import Color from 'color'

import Component from '../core/Component'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'

export const Events = {
    Enter: 'section:enter',
    Leave: 'section:leave',
}

export default class Section extends Component {
    constructor(element) {
        super(element)

        this.state = {
            active: false,
            ready: false,
        }
    }

    prepare() {
        // do not initialize if the element does not have a scope color class
        if (!this.element.matches('[class*="u-scope"]')) {
            return
        }

        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)

        try {
            const color = Color(
                window.getComputedStyle(this.element).getPropertyValue('background-color'),
            ).hsl()
            const [hue, saturation, luminosity] = color.color

            this.type = luminosity < 50 ? 'dark' : 'light'
        } catch (e) {
            this.type = 'dark'
        }

        setTimeout(() => {
            this.resize()
            this.render(Scroll.getScroll().y)
        }, 100)
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
    }

    handleResize = () => {
        setTimeout(() => {
            this.resize()
            this.render(Scroll.getScroll().y)
        }, 100)
    }

    handleScroll = ({ offset }) => {
        this.render(offset.y)
    }

    resize() {
        this.windowHeight = window.innerHeight

        const toggleBox = document
            .getElementById('fixed-navigation-toggle')
            ?.getBoundingClientRect()

        const mobileToggleBox = document
            .getElementById('fixed-navigation-toggle-mobile')
            ?.getBoundingClientRect()

        const toggleHeight = toggleBox.height || mobileToggleBox.height || 0
        const toggleTop = toggleBox.top || mobileToggleBox.top || 0

        const box = this.element.getBoundingClientRect()
        const offset = Scroll.getScroll()
        const top = box.top + offset.y

        this.box = {
            top: top,
            height: box.height,
            start: top - this.windowHeight,
            threshold: top,
            stop: top + box.height,
            headerTop: top - toggleTop - toggleHeight / 2,
            headerBottom: top + box.height - toggleTop - toggleHeight / 2,
        }
        this.state.ready = true
    }

    render(y) {
        if (!this.state.ready) {
            return
        }

        if (y > this.box.headerTop && y < this.box.headerBottom) {
            if (!this.state.active) {
                this.state.active = true
                EventBus.emit(Events.Enter, {
                    type: this.type,
                    element: this.element,
                })
            }
        } else {
            if (this.state.active) {
                this.state.active = false
                EventBus.emit(Events.Leave, {
                    type: this.type,
                    element: this.element,
                })
            }
        }
    }
}
